import { render, staticRenderFns } from "./VendorPayment.vue?vue&type=template&id=c1119af0&scoped=true&"
import script from "./VendorPayment.vue?vue&type=script&lang=js&"
export * from "./VendorPayment.vue?vue&type=script&lang=js&"
import style0 from "./VendorPayment.vue?vue&type=style&index=0&id=c1119af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1119af0",
  null
  
)

export default component.exports